import { Box, Typography, Stack } from '@mui/material';
import type { PageHeaderProperties } from '@/types/application/common/components/layout/page-header';

export function PageHeader({ title, subtitle, actions }: PageHeaderProperties) {
  return (
    <Stack
      direction={{ xs: 'column', sm: 'row' }}
      justifyContent="space-between"
      alignItems={{ sm: 'center' }}
      gap={2}
      mb={3}
    >
      <Box>
        {typeof title === 'string' ? (
          <Typography variant="h4">{title}</Typography>
        ) : (
          title
        )}
        {subtitle && (
          <Typography variant="body2" color="text.secondary">
            {subtitle}
          </Typography>
        )}
      </Box>
      {actions && (
        <Stack direction="row" gap={1.5} alignItems="center">
          {actions}
        </Stack>
      )}
    </Stack>
  );
}

export default PageHeader;


